import { createJSONStorage, persist } from 'zustand/middleware';
import { create } from 'zustand/react';

export interface CheckoutUIState {
  isGifting: boolean;
  manufactureNow?: boolean;
  ownerIsApplicant?: boolean;
  giftingType?: number;
  isGiftingAdded: boolean;
  paymentType: number;
  isAcceptStatement: boolean;

  updateState: <K extends keyof CheckoutUIState>(
    key: K,
    value: CheckoutUIState[K],
  ) => void;
  updateMultiple: (
    updates: Partial<Omit<CheckoutUIState, 'updateState' | 'updateMultiple'>>,
  ) => void;
  resetUIStore: () => void;
}

const initialUIState = {
  isGifting: false, // Provide initial state
  manufactureNow: undefined,
  ownerIsApplicant: undefined,
  giftingType: undefined,
  isGiftingAdded: false,
  paymentType: 1,
  isAcceptStatement: false,
};

export const useCheckoutUIStore = create<CheckoutUIState>()(
  persist<CheckoutUIState>(
    (set, get) => ({
      ...initialUIState,
      updateState: (key, value) => set((state) => ({ ...state, [key]: value })),

      updateMultiple: (updates) => set((state) => ({ ...state, ...updates })),
      resetUIStore: () => set(initialUIState),
    }),
    {
      name: 'checkout-ui',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
